import { Typography } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0 2px;
`;

export const Title = styled(Typography.Text)`
  && {
    font-size: 16px;
    line-height: 24px;
    color: ${COLOR_OPTIONS.NEUTRAL_100};
    letter-spacing: -0.12px;
    font-weight: 600;
  }
`;

export const Description = styled(Typography.Text)`
  && {
    font-size: 14px;
    line-height: 20px;
    color: ${COLOR_OPTIONS.NEUTRAL_60};
    letter-spacing: -0.105px;
    text-align: center;
    font-weight: 400;
  }
`;
